export const deckSettingsModalOnboardingKey = 'deck-settings-modal'

export const defaultJoinSlide = (title = null) => ({
  content: {
    image: null,
    title: title || 'Join this Event',
    subtitle: 'A really nifty subtitle goes here'
  },
  prompts: {},
  answers: [],
  options: {},
  steps: [],
  order: 1,
  template: 'joinSlide',
  __typename: 'slides'
})

export const demoDeckId = 14391

export const templateDecks = [
  { id: null, name: 'Blank', img: 'blank-presentation.svg' },
  { id: 117703, name: 'Training / Learning', img: 'brainstorm-paper.svg' },
  { id: 117717, name: 'Live Poll / Survey', img: 'pie-chart.svg' },
  { id: 116284, name: 'Live Quiz / Trivia', img: 'users-right-wrong.svg' },
  { id: 117726, name: 'Team Check-in', img: 'phone-response.svg', scale: 1.1 },
  { id: 119420, name: 'Team Building', img: 'raise-hands.svg' },
  { id: 119415, name: 'Word Cloud', img: 'chat-bubbles-phone.svg' },
  { id: 119435, name: 'Icebreaker / Energizer', img: 'raised-hands-hearts.svg', scale: 1.1 },
  { id: 119459, name: 'Knowledge Check-in', img: 'brainstorm-bulb.svg' },
  { id: 119478, name: 'Trivia Game', img: 'podium.svg' },
  { id: 120070, name: 'Q&A', img: 'qa-bubbles.svg' },
  { id: 120468, name: 'Photo Share', img: 'photo-likes.svg' }
]

export const templateDecksForEdu = [
  { id: null, name: 'Blank', img: 'blank-presentation.svg' },
  { id: 120471, name: 'Lesson', img: 'brainstorm-paper.svg' },
  { id: 117717, name: 'Live Poll / Survey', img: 'pie-chart.svg' },
  { id: 116284, name: 'Live Quiz / Trivia', img: 'users-right-wrong.svg' },
  { id: 119415, name: 'Word Cloud', img: 'chat-bubbles-phone.svg' },
  { id: 120472, name: 'Classroom Game', img: 'raise-hands.svg' },
  { id: 119435, name: 'Icebreaker / Energizer', img: 'raised-hands-hearts.svg', scale: 1.1 },
  { id: 119478, name: 'Trivia Game', img: 'podium.svg' },
  { id: 119459, name: 'Knowledge Assessment', img: 'brainstorm-bulb.svg' },
  { id: 120070, name: 'Q&A', img: 'qa-bubbles.svg' },
  { id: 120475, name: 'Student Check-in', img: 'phone-response.svg', scale: 1.1 },
  { id: 120468, name: 'Photo Share', img: 'photo-likes.svg' }
]

export const quickStartDecks = [
  { id: 420, userTypes: ['work'], seasonal: { start: '10/29', end: '01/04' } },
  { id: 14123, userTypes: ['work'], seasonal: { start: '10/29', end: '01/04' } },
  { id: 389, userTypes: ['work'], seasonal: { start: '11/01', end: '11/30' } },
  { id: 10375, userTypes: ['work'] }, // meeting icebreaker
  { id: 8797, userTypes: ['work'] }, // team building game
  { id: 39117, userTypes: ['work'] }, // interactive conference activity
  { id: 14043, userTypes: ['work'], seasonal: { start: '10/29', end: '01/04' } },
  { id: 14124, userTypes: ['work'], seasonal: { start: '10/29', end: '01/04' } },
  { id: 10315, userTypes: ['work'] },
  { id: 8718, userTypes: ['work'] },
  { id: 10368, userTypes: ['work'] },
  { id: 13239, userTypes: ['work'] },
  { id: 18685, userTypes: ['work'] },
  { id: 54084, userTypes: ['work'] },
  { id: 11952, userTypes: ['work'] },
  { id: 17473, userTypes: ['edu'] },
  { id: 2633, userTypes: ['work', 'edu'] }, // get to know the group game
  { id: 21318, userTypes: ['edu'] }, // class icebreaker
  { id: 14277, userTypes: ['work', 'edu'], seasonal: { start: '10/01', end: '11/02' } },
  { id: 338, userTypes: ['work', 'edu'], seasonal: { start: '10/01', end: '11/02' } },
  { id: 16163, userTypes: ['work', 'edu'], seasonal: { start: '02/01', end: '02/16' } },
  { id: 18887, userTypes: ['work', 'edu'], seasonal: { start: '03/10', end: '03/19' } },
  { id: 20499, userTypes: ['work', 'edu'], seasonal: { start: '04/14', end: '04/24' } },
  { id: 1551, userTypes: ['work', 'edu'] }, // catch up with your crew
  { id: 14276, userTypes: ['work', 'edu'] },
  { id: 1556, userTypes: ['work', 'edu'] },
  { id: 17488, userTypes: ['edu'] },
  { id: 39396, userTypes: ['work'], seasonal: { start: '01/25', end: '02/28' } }, // black history month
  { id: 50685, userTypes: ['work'] },
  { id: 10857, userTypes: ['work'] },
  { id: 46930, userTypes: ['work'] },
  { id: 34813, userTypes: ['edu'], seasonal: { start: '10/29', end: '01/04' } },
  { id: 56425, userTypes: ['edu'], seasonal: { start: '06/24', end: '07/07' } },
  { id: 53198, userTypes: ['work', 'edu'], seasonal: { start: '05/25', end: '06/30' } }, // pride month
  { id: 46683, userTypes: ['work'] },
  { id: 29, userTypes: ['work'] },
  { id: 7083, userTypes: ['work'] },
  { id: 44801, userTypes: ['work'] },
  { id: 222, userTypes: ['work'] }
]

export const popularDeckIds = [
  26,
  29,
  43,
  68,
  222,
  235,
  336,
  338,
  383,
  385,
  389,
  391,
  401,
  420,
  499,
  619,
  630,
  642,
  844,
  932,
  1551,
  1554,
  1556,
  1728,
  1996,
  2227,
  2633,
  3603,
  6433,
  6727,
  6900,
  7083,
  8516,
  8718,
  8797,
  8920,
  10315,
  10368,
  10375,
  10376,
  10760,
  10857,
  10992,
  11952,
  12964,
  12941,
  13239,
  13840,
  13842,
  14043,
  14122,
  14123,
  14124,
  14276,
  14277,
  15678,
  15712,
  15713,
  15726,
  15725,
  16068,
  16161,
  16163,
  14217,
  17488,
  17473,
  17447,
  17217,
  18685,
  18804,
  18887,
  19013,
  20499,
  20809,
  21318,
  17488,
  24679,
  24257,
  24790,
  25348,
  25748,
  26253,
  26489,
  26502,
  25594,
  27385,
  38285,
  39117,
  39031,
  39396,
  39547,
  39774,
  43319,
  44801,
  46683,
  46930,
  47000,
  50397,
  48641,
  50685,
  51218,
  53198,
  53193,
  54084,
  55527,
  56425,
  56815
]
